import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MobileAppDialogComponent, MobileAppDialogData } from './mobile-app-dialog.component';

@Injectable({ providedIn: 'root' })
export class MobileAppPromptService {
  private document = inject(DOCUMENT);
  private dialog = inject(MatDialog);

  prompt(): void {
    const navigator = this.document.defaultView?.navigator;
    if (!navigator) return;

    const { userAgent, maxTouchPoints } = navigator;
    let data: MobileAppDialogData;

    if (/android/i.test(userAgent)) {
      data = {
        storeUrl: 'https://play.google.com/store/apps/details?id=com.umgrauemeio.pantera',
        storeName: 'Google Play',
      };
    } else if (
      /iPhone|iPad|iPod/i.test(userAgent) ||
      (/Macintosh/i.test(userAgent) && maxTouchPoints > 1)
    ) {
      data = { storeUrl: 'https://apps.apple.com/app/id6502342221', storeName: 'App Store' };
    } else {
      return;
    }

    this.dialog.open(MobileAppDialogComponent, {
      data,
      width: '100vw',
      height: '100%',
      maxWidth: '100vw',
      panelClass: 'mobile-app-dialog-panel',
      ariaLabelledBy: 'mobile-app-title',
      autoFocus: false,
    });
  }
}
